import { render } from "./PriceChangeIndicator.vue?vue&type=template&id=e043946c&scoped=true"
import script from "./PriceChangeIndicator.vue?vue&type=script&lang=js"
export * from "./PriceChangeIndicator.vue?vue&type=script&lang=js"

import "./PriceChangeIndicator.vue?vue&type=style&index=0&id=e043946c&lang=scss&scoped=true"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e043946c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
